import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { Store } from '../../../../../state/store.interfaces';
import { Dataset } from '../../../../Analysis/Detail/interfaces';
import { Histogram } from '../../../../Pdfs/TransferGraph/Histogram';
import * as weighingTransfersSlice from '../../weighingTransfersSlice';
import { getModalWidth } from '../../../../OptimalHarvestPoint/helpers';
import { LrvModal } from '../../../../../common/components/LrvModal/LrvModal';
import { getDataset } from '../../../../Analysis/Detail/histogram.helpers';
import { typeHistogram } from '../../../../../config/commons';

import styles from './TransferMetricChart.module.scss';

interface Props {
  theme?: 'dark' | 'light';
}

export const TransferHistogram = (props: Props) => {
  const { theme = 'light' } = props;

  const [t] = useTranslation();
  const dispatch = useDispatch();

  const { graphWidth, modalWidth, graphHeight } = getModalWidth();

  const {
    showHistogramModal,
    capsules,
  } = useSelector((state: Store) => state.weighingTransfers);

  const { transfer } = capsules;

  if (!transfer?.histogramWeight?.frequencies) {
    return null;
  }
  
  const frequency = transfer.histogramWeight.frequencies;
  const total = frequency.reduce((accumulator, value) => accumulator + value, 0);
  const dataset: Dataset[] = getDataset({ frequencyData: transfer.histogramWeight, animals: total });

  const onCancel = () => {
    dispatch(weighingTransfersSlice.setShowHistogramModal(false));
  };

  return (
    <LrvModal
      theme={theme}
      title={t('detail.pdf.histogramWeight')}
      open={showHistogramModal}
      forceRender={true}
      destroyOnClose={true}
      closable={false}
      onCancel={onCancel}
      className={styles.chartModal}
      width={modalWidth}
      okButtonProps={{ style: { display: 'none' } }}
    >
      <Histogram
        histogram={typeHistogram.WEIGHT}
        primaryLimits={transfer?.histogramWeight.limits}
        primaryDataset={dataset}
        secondaryLimits={[]}
        secondaryDataset={[]}
        renderPdf={false}
        height={graphHeight}
        width={graphWidth}
      />
    </LrvModal>
  );
};
